import { render, staticRenderFns } from "./DepositPage.vue?vue&type=template&id=b55ebb6e"
import script from "./DepositPage.vue?vue&type=script&lang=js"
export * from "./DepositPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports